<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>Choix de l'organisation à activer</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (data.organizations) {
        <div class="container">
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="organization" tabindex="1" (selectionChange)="onOrganizationSelected($event)">
                        @for (organization of data.organizations; track organization.id) {
                        <mat-option [value]="organization">{{ organization.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        } @else {
        <div class="no-organization">Aucune organisation n'est activable.</div>
        }
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="data">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data">Activer</button>
    </mat-card-actions>
</mat-card>
